import { buildBuilderSeatsEndpoints } from "../../../../core/store/reduxApi/builderSeats";
import { BuilderSeatsTag, reduxApiSlice } from "./index";

export type {
  BuilderSeatDto,
  ListBuilderSeatsResponse,
} from "../../../../core/store/reduxApi/builderSeats";

const extendedApi = reduxApiSlice.injectEndpoints({
  endpoints: (builder) => buildBuilderSeatsEndpoints(builder, BuilderSeatsTag),
  overrideExisting: false,
});

export const {
  useListBuilderSeatsQuery,
  useAssignBuilderSeatMutation,
  useUnassignBuilderSeatMutation,
} = extendedApi;
